export const tokenName = 'tokenAAA';
export const roleNone = 'None';
export const roleViewer = 'Viewer';
export const roleContributor = 'Contributor';
export const roleOwner = 'Owner';
export const roleAdmin = 'Admin';
export const promoTypeNone = 'None'
export const promoTypePercentage = 'PE'
export const promoTypeFixedAmount = 'FA'
export const promoTypeOther = 'OT'
export const promoTypeWaived = 'WA'
export const promoTypeFreeAssociates = 'FS'
export const editorExcludeCharacters = ['[', ']', '{', '}', '^', '<', '>', '+', '=']
export const editorToolbar = [
    [{ 'header': [1, false] }],
    [{ 'size': ['small', false] }],
    ['bold', 'italic'],
    [{ 'color': [] }],
    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
]